import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/button/ActionButton';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { AddIcon } from 'assets/materialIcons/materialIcons';
import { Link } from 'react-router-dom';

const AddButton = (props) => {
    const {
        basePath,
        translate,
    } = props;

    const defaultLinkStyle = {
        textDecoration: 'none',
        display: 'inline-flex',
        cursor: 'pointer',
    };

    return (
        <Link to={ `/${ basePath }/create` } style={ defaultLinkStyle }>
            <Button
                icon={ <AddIcon color={ theme.palette.doveGray }/> }
                title={ translate('actions.add') }
                primary={ false }
            />
        </Link>
    );
};

AddButton.propTypes = {
    basePath: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
};

export default translate(AddButton);



// WEBPACK FOOTER //
// ./src/components/button/AddButton.js